import { render, staticRenderFns } from "./MoleculeContentEditorBlockDocument.vue?vue&type=template&id=9d62aeb8&"
import script from "./MoleculeContentEditorBlockDocument.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentEditorBlockDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports